import { ParsedUrlQuery } from 'node:querystring';

export function isInitialView(queryParameters: ParsedUrlQuery, searchValue: string | undefined) {
  const filterKeys = [
    'scope',
    'price',
    'school',
    'skill',
    'difficulty',
    'duration',
    'rawDuration',
    'type',
    'sort',
    'page',
    'language',
  ];

  const isDefaultPage = filterKeys.every((key) => queryParameters[key] === undefined);
  const initialSearchValue = undefined;

  return isDefaultPage && searchValue === initialSearchValue;
}
